// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"e12c473f","453":"458b5bc1","484":"405b3f08","629":"cb4456e5","682":"626a82a4","818":"5e1e8801"}[chunkId] + ".chunk.js";
};